import React from 'react'
import {observer} from 'mobx-react'
import {FilterContainer, IFilterContainerStore} from '@/components'
import {useInjection} from 'dna-react-ioc'
export const PayByLinkFilterButtonStoreSymbol = Symbol('PayByLinkFilterButtonStore')

export const PayByLinkFilterButton = observer(() => {
    const filterStore = useInjection<IFilterContainerStore>(PayByLinkFilterButtonStoreSymbol)

    return (
        <FilterContainer store={filterStore} formId={'pay-by-link-popover-filter-form'}/>
    )
})
